import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

interface ITag {
  color?: string;
  limitOfLines: number;
}

export const TagDiv = styled.div<ITag>`
  display: flex;
  padding: 4px 12px;
  border-radius: 15px;
  background-color: ${({ color }) => color || '#edeff4'};
  color: ${({ color }) => {
    if (color === '#E7E4F9') return '#524988';
    if (color === '#DCF2EA') return '#317159';
    if (color === '#FFEFD2') return '#66460D';
    if (color === '#D3F5F7') return '#0F5156';
    if (color === '#F8E3DA') return '#85462B';
    if (color === '#FBDDF3') return '#8E3374';
    if (color === '#F9DADA') return '#7D2828';
    if (color === '#E6EDFF') return '#1F3D99';
    return '#474d66';
  }};
  font-size: 14px;
  font-weight: 500;
  align-items: center;
  justify-content: center;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;
